import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { SeguroStore } from '@interfaces/seguro-store.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private httpBackend: HttpBackend) {}

  obtenerToken(): Observable<{ token: string }> {
    const http = new HttpClient(this.httpBackend);
    let param = environment.IdApp.toString();
    const httpHeaders = new HttpHeaders({
      APP: param,
    });
    let Respuesta = http.get<any>(environment.URL_API + '/Login/Authenticate', {
      headers: httpHeaders,
    });

    return Respuesta;
  }

  procesarToken(respuesta: any): SeguroStore {
    return respuesta;
  }
}
